import script from "./RichText.vue?vue&type=script&setup=true&lang=js"
export * from "./RichText.vue?vue&type=script&setup=true&lang=js"

import "./RichText.vue?vue&type=style&index=0&id=96d36838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96d36838"]])

export default __exports__